<script>
import { mapGetters } from "vuex";
import { GETTOKEN} from "../SystemFuns";

export default {
  computed: {
    ...mapGetters("app", ["phoneModel", "isHOM", "isAndroid", "isIOS"])
  },
  mounted() {
    // 提醒
    window.getCrmTokenCallback = this.getCrmTokenCallback; //返回token数据
    if (window.webkit) {
      window.webkit.messageHandlers.getCrmTokenCallback.onmessage = this.getCrmTokenCallback; // 返回token数据
    }
  },
  methods: {
    //ios token返回
    getSysToken(){
      GETTOKEN()
    },
    getCrmTokenCallback(result){
      console.log(result,'getCrmTokenCallback');
      this.handleGetTokenResult(result)
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/systemFolder/mixins/getSystemTokenPage.vue